import { useState } from 'react'
import { useZoom } from './useZoom'

const useZoomEvent = () => {
  const [element, setElement] = useState(null)

  useZoom({ element })

  const onFocus = (e = {}, isZoomDisabled) => {
    if (isZoomDisabled) return
    if (e && e.target && e.target.addEventListener) {
      e.target.addEventListener('blur', onBlur)
    }
    if (!!e.nativeEvent) {
      setElement(e.nativeEvent.target)
      return
    }
    setElement(e.target)
  }

  const onBlur = (e = {}) => {
    if (e && e.target && e.target.removeEventListener) {
      e.target.removeEventListener('blur', onBlur)
    }
    setElement(null)
  }

  return { onFocus, onBlur }
}

export { useZoomEvent }
export default useZoomEvent
